/**
 * Configurazione API
 * Auto-rileva il dominio corrente per produzione
 * o usa la variabile d'ambiente per sviluppo
 */

// In produzione (browser), usa il dominio corrente
// In sviluppo, usa la variabile d'ambiente
const getBackendUrl = () => {
  // Se siamo nel browser
  if (typeof window !== 'undefined') {
    const currentHost = window.location.origin;
    
    // Se siamo su emergent.host o ilcondominiofacile.it, usa il dominio corrente
    if (currentHost.includes('emergent.host') || 
        currentHost.includes('ilcondominiofacile.it')) {
      return currentHost;
    }
  }
  
  // Fallback alla variabile d'ambiente (sviluppo/preview)
  return process.env.REACT_APP_BACKEND_URL || '';
};

export const BACKEND_URL = getBackendUrl();
export const API = `${BACKEND_URL}/api`;
